export default __webpack_public_path__ + "static/Temp_TXRoom-bed68e3632ad87e6118afce9f3e9ba82.webp";